<div class="unauthorized-container">
    <div class="card unauthorized">
      <div class="card-header">
        <img src="../../../../assets/images/unath.png">
      </div>
      <div class="card-body">
        <h4 class="card-title">Unsupported</h4>
        <h6> The browser not supported</h6>
        </div>
    </div>
</div>